var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.903 8.468 19.348 0h-1.764l-6.465 7.353L5.956 0H0l7.808 11.12L0 20h1.764l6.827-7.766L14.044 20H20L11.902 8.468m-2.417 2.75-.791-1.108L2.4 1.3h2.71l5.08 7.11.791 1.107 6.603 9.242h-2.71z"
})));
export default SvgX24;